import { forwardRef } from 'react';
import classNames from 'classnames';

import { SvgIconComponent } from '../types/svgs';

type IconButtonProps = {
  IconComponent: SvgIconComponent;
  ['aria-label']: string;
  iconClassName?: string;
  hoverClassName?: string;
} & React.ComponentProps<'button'>;

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      IconComponent,
      iconClassName,
      hoverClassName,
      className,
      disabled,
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          'group flex items-center rounded p-1 text-green-150 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-secondary-50 disabled:text-neutral-100',
          disabled
            ? 'cursor-not-allowed opacity-50 hover:bg-transparent'
            : hoverClassName ?? 'hover:bg-neutral-75',
          className,
        )}
        disabled={disabled}
        title={rest['aria-label']}
        {...rest}
      >
        <IconComponent className={classNames(iconClassName)} />
        {children}
      </button>
    );
  },
);

export default IconButton;
